export default "__VITE_ASSET__BPxYGyQz__"